<template>
  <article class="contact-full">
    <!-- Image -->
    <figure class="contact-full__image">
      <slot name="image" />
    </figure>

    <!-- Header -->
    <div class="contact-full__header">
      <slot name="header" />
    </div>

    <!-- Detail -->
    <div class="contact-full__detail">
      <slot name="detail" />

      <div class="contact-full__map">
        <slot name="map" />
      </div>
    </div>
  </article>
</template>

<script>
export default {
  name: 'ContactFull'
};
</script>

<style lang="scss" src="@/assets/components/contact/contact-full-view.scss"></style>



// WEBPACK FOOTER //
// contact-full-view.vue